/** Shared estimate lock check — aligned with backend is_estimate_locked() */
const LOCKED_STATUSES = ["Accepted", "Closed"] as const;

export function isEstimateTakeoffLocked(status: string | null | undefined): boolean {
  if (!status) return false;
  return (LOCKED_STATUSES as readonly string[]).includes(status);
}
